<template>
  <div>
    <h1 class="headline">{{headerText}}</h1>
    <p>{{snippet}}</p>

    <div class="toggle-list mdl-shadow--2dp">
      <toggle-list-item
        value="yes"
        icon="portrait"
        toggle-icon="check"
        text="Yes"
        :checked-status="isResident === 'yes'"
        toggle-class="toggle-content-action"
        @inputting="setIsResident"
      />

      <toggle-list-item
        value="no"
        icon="crop_din"
        toggle-icon="check"
        text="No"
        :checked-status="isResident === 'no'"
        toggle-class="toggle-content-action"
        @inputting="setIsResident"
      />
    </div>

    <div class="App-buttons">
      <button-component
        direction="back"
        value="Back"
      />
      <button-component
        color="primary"
        value="Next Step"
        :is-disabled="isDisabled"
      />
    </div>
  </div>
</template>

<script>
import ButtonComponent from './Button.vue';
import ToggleListItem from './Questions/ToggleListItem.vue';
import {mapActions, mapGetters} from 'vuex';
import _ from 'lodash';

export default {
  components: {
    ButtonComponent,
    ToggleListItem
  },
  computed: {
    ...mapGetters('resident', ['isResident']),
    ...mapGetters({
      displayOptions: 'displayOptions'
    }),
    isDisabled() {
      return !this.isResident;
    }
  },
  data() {
    return {
      headerText: 'Do you live in this suite?',
      snippet: 'ie. Is your suite owner-occupied'
    };
  },
  methods: {
    ...mapActions('resident', ['setIsResident']),
    setCustomText() {
      if (!_.has(this.displayOptions, 'isresident')) {
        return;
      }
      const opts = this.displayOptions.isresident;

      // Only use custom text for the ones provided, otherwise use default
      this.headerText = opts.header_text || this.headerText;
      this.snippet = opts.snippet || this.snippet;
    }
  },
  mounted() {
    this.setCustomText();
    this.$nextTick(() => {
      componentHandler.upgradeAllRegistered();
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/IsResident.vue